var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShoutouts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8413 13.2507C17.4255 13.4928 16.9066 13.3936 16.6044 13.0395L11.2277 14.3591C11.6982 15.6861 11.1755 17.2073 9.92375 17.9359C8.51535 18.7556 6.70653 18.268 5.89274 16.8469C5.69768 16.5063 5.57502 16.1357 5.52502 15.7587L4.43171 16.027C4.39314 16.3223 4.22371 16.5969 3.9483 16.7572C3.47807 17.0309 2.87611 16.8683 2.60463 16.3942L0.965236 13.5315C0.693753 13.0575 0.855048 12.4506 1.32527 12.1769C1.60326 12.0151 1.92728 12.0058 2.20185 12.1231L10.8836 3.07678C10.6705 2.61601 10.8389 2.05884 11.2838 1.7999C11.754 1.5262 12.356 1.68881 12.6274 2.16288L12.9449 2.71723L12.9556 2.73543L17.9223 11.4083L17.9326 11.4267L18.2014 11.8961C18.4728 12.3701 18.3115 12.977 17.8413 13.2507ZM9.28389 14.8362L7.46728 15.282C7.4488 15.4733 7.49173 15.6724 7.59579 15.8541C7.86727 16.3282 8.47037 16.4901 8.93946 16.2171C9.40854 15.944 9.57097 15.3365 9.30015 14.8636C9.29481 14.8543 9.28939 14.8451 9.28389 14.8362Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoutouts);
export default __webpack_public_path__ + "static/media/icon-shoutouts.f02fb75b959960e11c8ec75ea8402782.svg";
export { ForwardRef as ReactComponent };